<div
  [formGroup]="form"
  fxLayout="row wrap"
  fxLayoutGap="32px 0 grid"
  fxLayoutAlign="flex-start"
>
  <div class="input-container" fxFlex="0 1 50%">
    <label>{{ label }}</label>
    <mat-form-field
      appearance="outline"
      floatLabel="always"
      [ngClass]="isReadOnly ? 'mat-form-field-readonly' : ''"
    >
      <input
        formControlName="addressLine1"
        matInput
        placeholder="Address line 1"
        [tabIndex]="tabIndex"
        [readonly]="isReadOnly"
      />
      <mat-error *ngIf="hasError('addressLine1', 'required')">
        Address Line 1 is <strong>Required</strong>
      </mat-error>
    </mat-form-field>

    <mat-form-field
      appearance="outline"
      floatLabel="always"
      [ngClass]="isReadOnly ? 'mat-form-field-readonly' : ''"
    >
      <input
        formControlName="addressLine2"
        matInput
        placeholder="Address Line 2"
        [tabIndex]="tabIndex + 1"
        [readonly]="isReadOnly"
      />
    </mat-form-field>
  </div>

  <div class="input-container" fxFlex="0 1 50%">
    <label>City </label>
    <mat-form-field
      appearance="outline"
      floatLabel="always"
      [ngClass]="isReadOnly ? 'mat-form-field-readonly' : ''"
    >
      <input
        matInput
        formControlName="city"
        [readonly]="isReadOnly"
        [tabIndex]="tabIndex + 2"
      />
      <mat-error *ngIf="hasError('city', 'required')">
        City is <strong>Required</strong>
      </mat-error>
      <mat-error class="error" *ngIf="hasError('city', 'pattern')">
        City must be alphabets only
      </mat-error>
    </mat-form-field>
  </div>

  <div class="input-container" fxFlex="0 1 50%">
    <label>{{ stateLabel }}</label>
    <digital-platform-state-select
      formControlName="stateCode"
      display="label"
      [country]="form.value.country"
      [tabIndex]="tabIndex + 4"
      [isDisabled]="isReadOnly"
    ></digital-platform-state-select>
  </div>

  <div class="input-container" fxFlex="0 1 50%">
    <label>{{ postalCodeLabel }}</label>
    <mat-form-field
      appearance="outline"
      floatLabel="always"
      [ngClass]="isReadOnly ? 'mat-form-field-readonly' : ''"
    >
      <input
        formControlName="postalCode"
        matInput
        [digitalPlatformZipFormat]="form.value.country"
        [tabIndex]="tabIndex + 5"
        [readonly]="isReadOnly"
      />
      <mat-error *ngIf="hasError('postalCode', 'required')">
        {{ postalCodeLabel }} is <strong>Required</strong>
      </mat-error>
      <mat-error
        *ngIf="hasError('postalCode', 'pattern')"
        [innerHTML]="postalCodePatternError()"
      >
      </mat-error>
    </mat-form-field>
  </div>

  <div class="input-container" fxFlex="0 1 50%">
    <label>Country</label>
    <mat-form-field appearance="outline" floatLabel="always">
      <mat-select
        formControlName="country"
        [tabIndex]="tabIndex + 3"
        [disabled]="isReadOnly"
      >
        <mat-option value="CA">Canada</mat-option>
        <mat-option value="MX">Mexico</mat-option>
        <mat-option value="US">United States</mat-option>
      </mat-select>
      <mat-error *ngIf="hasError('country', 'required')">
        Country is <strong>Required</strong>
      </mat-error>
    </mat-form-field>
  </div>

  <div class="input-container" fxFlex="0 1 50%">
    <label>{{ countyLabel }}</label>
    <mat-form-field appearance="outline" floatLabel="always">
      <input matInput formControlName="county" [tabIndex]="tabIndex + 6" />
      <mat-error *ngIf="hasError('county', 'required')">
        {{ countyLabel }} is <strong>Required</strong>
      </mat-error>
      <mat-error class="error" *ngIf="hasError('county', 'pattern')">
        {{ countyLabel }} must be alphabets only
      </mat-error>
    </mat-form-field>
  </div>
</div>
